import * as styles from "./ItemAttribute.module.css";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {message, Tag, Tooltip} from "antd";
import React from "react";
import {Link} from "react-router-dom";
import {FiExternalLink} from "react-icons/fi";
import CopyToClipboard from "react-copy-to-clipboard";
import {BsSearch} from "react-icons/bs";
import {onlyText} from "react-children-utilities";
import {FormPersister} from "../../sal-ui/FormPersister";

interface AttributeBoxProps {
    value: React.ReactNode;
    warningTitle?: React.ReactNode;
    href?: string;
    showSearch?: boolean;
    clipboardText?: string;
    attributeName?: string;
    attributeValue?: unknown;
    color?: string;
}

function AttributeBox(props: AttributeBoxProps) {
    const showSearch = props.showSearch ?? true;
    const warningIcon = props.warningTitle && (
        <Tooltip title={props.warningTitle}>
            <ExclamationCircleOutlined className={styles.warningIcon}/>
        </Tooltip>
    );

    const tag = <Tag color={props.color ?? "geekblue"} className={styles.container}>
        {props.value}
        {warningIcon}
        {showSearch && <Link
            to={`/vul-source-items?${createFilterParam(props.value, props.attributeName, props.attributeValue)}`}
            target={"_blank"}
            rel={"noopener noreferrer"}
        >
            <BsSearch className={"anticon"} title={"Search in items"}/>
        </Link>}
        {props.href && <a href={props.href} target={"_blank"} rel={"noopener noreferrer"}>
            <FiExternalLink className={"anticon"} title={"Open external link"}/>
        </a>}
    </Tag>

    if (props.clipboardText) {
        return <CopyToClipboard text={props.clipboardText} onCopy={text => message.info(<>Value <b>{text}</b> copied to clipboard.</>)}>
            <span className={styles.clipboardable}>{tag}</span>
        </CopyToClipboard>;
    } else {
        return tag;
    }
}

function createFilterParam(value: React.ReactNode, attributeName?: string, attributeValue?: unknown) {
    const textValue = onlyText(value);
    const isCveAttribute = attributeName === "cveId" || (!attributeName && textValue?.startsWith("CVE-"));
    let values: any;

    if (isCveAttribute) {
        values = {cveId: textValue};
    } else if (attributeName) {
        values = {
            attributes: [{
                name: attributeName,
                operator: "jsonEq",
                value: attributeValue ?? textValue
            }]
        };
    } else {
        values = {attributeValue: textValue};
    }

    const filter: any = {
        typeHints: {},
        values
    }

    const searchParams = new URLSearchParams();

    searchParams.set("filter", FormPersister.encodeUrlState(filter))
    searchParams.set("$readOnly", "");

    return searchParams.toString();
}

export default AttributeBox;
